import { render, staticRenderFns } from "./PersonalCardTypeFilter.vue?vue&type=template&id=9563882a&"
import script from "./PersonalCardTypeFilter.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports